<div class="title" fxLayout="row" fxLayoutAlign="space-between end">
  <h1>{{'コンテンツ購入日次情報' | translate}}</h1>

  <div class="basic-button" fxLayoutGap="10px">
    <button mat-raised-button color="primary" (click)="openSearch()" [disabled]="false">
      <mat-icon>search</mat-icon>
      <span>{{'条件' | translate}}</span>
    </button>
  </div>
</div>

<div class="filter-field" fxLayout="row" fxLayoutGap="20px">
  <mat-form-field fxFlex="25%">
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" autocomplete="off" #input>
  </mat-form-field>
</div>

<div fxLayout="column" fxLayoutAlign="center center" [formGroup]="editForm">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)">

    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef> No. </th>
      <td mat-cell *matCellDef="let daily; let i = index"> {{searchParameter.index == 0 ?  i + 1 : i + 1 + searchParameter.index * searchParameter.limit }} </td>
    </ng-container>

    <ng-container matColumnDef="facility_name">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'施設' | translate}} </th>
      <td mat-cell *matCellDef="let daily">
        <div *ngFor="let facility of facilities">
          <div *ngIf="daily.facility_id === facility.id">
            {{ facility.facility_names | multiName:projectLanguages:projectBaseLang }}
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'建物・カテゴリ' | translate}} </th>
      <td mat-cell *matCellDef="let daily">
        <div *ngFor="let hall of halls">
          <div *ngIf="daily.hall_id === hall.id">
            {{ hall.hall_names | multiName:projectLanguages:projectBaseLang }}
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="date">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'購入日' | translate}} </th>
      <td mat-cell *matCellDef="let daily"> {{ daily.date.toDate() | date: 'yyyy/MM/dd' }}</td>
    </ng-container>

    <ng-container matColumnDef="count">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'購入回数' | translate}} </th>
      <td mat-cell *matCellDef="let daily"> {{ daily.count | number }} </td>
    </ng-container>

    <ng-container matColumnDef="price">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'購入金額' | translate}} </th>
      <td mat-cell *matCellDef="let daily"> ¥{{ daily.price | number }} </td>
    </ng-container>

    <ng-container matColumnDef="preview">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'環境' | translate}} </th>
      <td mat-cell *matCellDef="let daily"> {{ daily.preview | preview }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <div fxFlex="67px">
    <div fxLayout="column" fxFlexFill fxLayoutAlign="start stretch">
      <div fxFlex='2px' style="background: #3F51B5;"></div>
      <div fxLayout="row" fxFlexFill fxLayoutAlign="end center">
        <div fxFlex>
          <div fxLayout="column" fxFlexFill fxLayoutAlign="start end" style="font-size: 12px; color: rgba(0,0,0,.54);">
            Items per page:
          </div>
        </div>
        <div fxFlex="10px"></div>
        <div fxFlex="56px" [style.fontSize.px]="12">
          <div fxLayout="column" fxFlexFill fxLayoutAlign="start stretch">
            <mat-form-field style="width: 75px;" appearance="outline" fxFlex>
              <mat-select formControlName="pagesize" (selectionChange)="onPageSizeChange($event)" [disabled]="!!isProcessing">
                <mat-option value=15>15</mat-option>
                <mat-option value=50>50</mat-option>
                <mat-option value=100>100</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div fxFlex="50px"></div>
        <div fxFlex="40px">
          <button mat-icon-button (click)="onPrevClick()" [disabled]="searchParameter.index === 0 || !searchParameter.prev_doc || !!isProcessing"><mat-icon>keyboard_arrow_left</mat-icon></button>
        </div>
        <div fxFlex="40px">
          <button mat-icon-button (click)="onNextClick()" [disabled]="!searchParameter.next_doc || !!isProcessing"><mat-icon>keyboard_arrow_right</mat-icon></button>
        </div>
        <div fxFlex="10px"></div>
      </div>
    </div>
  </div>

</div>